import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import Container from '@ui/container/container';
import { selectLoadingStylepacks, selectStylepacks } from '@/store/slices/stylepacks/selectors';
import { selectWorkingProject } from '@/store/slices/project/selectors';
import OptionalComponent from '@ui/optional-component/optional-component';
import EmptyStylepacksRow from './empty-stylepacks-row';
import useLoadStylepacks from './use-load-stylepacks';
import { useGreenroomStylepackShots } from '../../../stylepacks/utils/use-greenroom-stylepack-shots';
import { VideoType } from '@/types/stylepacks.types';

const skLoaderProps = {
  height: 85,
  width: 992,
  radius: 12,
};

const StylepacksRow = () => {
  useLoadStylepacks();

  const stylepacks = useAppSelector(selectStylepacks);
  const workingProject = useAppSelector(selectWorkingProject);
  const loadingStylepacks = useAppSelector(selectLoadingStylepacks);

  const selectedStylepack = useMemo(() => {
    const session = workingProject?.sessions[0];
    if (session?.streaming_options?.stylepackId && stylepacks) {
      return stylepacks.find((stylepack) => stylepack.stylePack === session?.streaming_options?.stylepackId);
    }
  }, [workingProject, stylepacks]);

  const filteredVideos = useGreenroomStylepackShots(selectedStylepack, VideoType.all);

  return (
    <Container margin="24px var(--main-content-horizontal-padding)" data-component="StylepacksRow">
      <Container className="H5 margin-b-8">Stylepacks™</Container>
      <Container height="85px" className="radius-12" skLoader={{ ...skLoaderProps, loading: loadingStylepacks }}>
        <OptionalComponent display={!selectedStylepack || filteredVideos?.length === 0}>
          <EmptyStylepacksRow stylepackSelected={!!selectedStylepack} />
        </OptionalComponent>
        <OptionalComponent display={!!selectedStylepack && filteredVideos?.length > 0}>
          <Container className="flex ai-center gap-10" height="85px">
            {(filteredVideos || []).slice(0, 6).map((video) => (
              <Container
                key={video.id}
                className="radius-12"
                height="85px"
                width="157px"
                backgroundImage={video.thumbnailUrl}
              />
            ))}
          </Container>
        </OptionalComponent>
      </Container>
    </Container>
  );
};

export default StylepacksRow;
